'use client';

import {createTheme} from '@mui/material/styles';

const colors = {
  primary: '#2D94DA',
  darkGrey: '#1e0316',
  secondary: '#E91293',
  primaryLight: '#EA129977',
}

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary
    },
    secondary: {
      main: colors.secondary
    }
  },
});

export default theme;
